module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"linkUrl":"Link url"}}')
  delete Component.options._Ctor
}
